import { Editor } from '@tinymce/tinymce-react';

const getLang = () => {
  const htmlLang = document.querySelector('html')?.getAttribute('lang');

  switch (htmlLang) {
    case 'cs':
      return 'cs';
    default:
      return null;
  }
};

const getLangUrl = (lang: string | null) => {
  if (!lang) return null;

  const resourceUrl = `${window.appContext}/res/components/editor/tinymce/langs`;

  return `${resourceUrl}/${lang}.js`;
};

interface TinyMCEProps {
  autoFocus?: boolean;
  height?: number;
  menubar?: boolean;
  plugins?: string[];
  value: string;
  toolbar?: string;
  onChange: (content: string) => void;
  onBlur?: () => void;
  disabled: boolean;
  id?: string;
}

export default class TinyMCE extends React.PureComponent<TinyMCEProps> {
  static defaultProps = {
    autoFocus: false,
    initialValue: '',
    height: 500,
    menubar: false,
    plugins: [
      'advlist autolink lists link image charmap print preview anchor',
      'searchreplace visualblocks code fullscreen',
      'insertdatetime media table paste code help wordcount',
    ],
    toolbar:
      'undo redo | formatselect | bold italic backcolor | \
            alignleft aligncenter alignright alignjustify | \
            bullist numlist outdent indent | removeformat | help',
  };

  onChange = (content: string) => {
    const { onChange } = this.props;
    onChange(content);
  };

  render() {
    const { value, height, menubar, plugins, toolbar, onBlur, disabled, id } = this.props;

    return (
      <Editor
        value={value}
        init={
          disabled
            ? {
                menubar: false,
                plugins: '',
                toolbar: '',
                language: getLang(),
                language_url: `${getLangUrl(getLang())}`,
                branding: false,
              }
            : {
                height,
                menubar: menubar,
                plugins,
                toolbar,
                language: getLang(),
                language_url: `${getLangUrl(getLang())}`,
                branding: false,
              }
        }
        onEditorChange={this.onChange}
        onBlur={onBlur}
        disabled={disabled}
        id={id}
      />
    );
  }
}
